import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'

import {resolveHelpURL} from '../../../../utils/url'
import {HINT_CATEGORY, toHintId} from '../Hints.types'
import type {Hint} from '../Hints.types'

import styles from './HintItems.css'

export const addAgentPoolHint: Hint = {
  id: toHintId('add-agent-pool'),
  name: 'Add pool',
  text: 'Add a new agent pool — a group of agents with a similar purpose. By assigning pools to specific projects, you can control which agents will be used for running these projects’ builds.',
  helpLink: resolveHelpURL('?Agent+Pool'),
  category: HINT_CATEGORY.agents,
  directions: [Directions.RIGHT_BOTTOM],
  className: styles.addAgentsPoolHint,
}
export const addAgentHint: Hint = {
  id: toHintId('add-agent'),
  name: 'Install Agent',
  text: 'Build agents are workers that run your builds. You can download an extra agent in a convenient format and install it on a dedicated machine.',
  helpLink: resolveHelpURL(
    '?Setting+up+and+Running+Additional+Build+Agents#Installing+Additional+Build+Agents',
  ),
  category: HINT_CATEGORY.agents,
}
export const authorizeAgentHint: Hint = {
  id: toHintId('unauthorized-agents'),
  name: 'Unauthorized agents',
  text: 'To be able to run builds, all new agents need to be authorized on this server.',
  category: HINT_CATEGORY.agents,
}
